<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <label for="">
          {{ $resourceString["myProject.Project.AddItemModal.Label.VtType"] }}
        </label>
        <div class="mb-2 justify-content-between align-items-center">
          <div class="input-group">
            <select
              @change="handleTrayType"
              name="virtualTrayType"
              class="form-control form-control-sm text-capitalize"
              required="required"
              v-model="selectedOption"
            >
              <option v-for="(item, index) in virtualTrayTypes" :key="index" :value="item.value">
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="pl-3 pt-3">
        <label for="">
          {{ $resourceString["account.MyTray.Button.AddTray"] }}
        </label>
    </div>
      <pc-search :cols="'sm-12'"/>
    </div>

    <div class="row mt-2"   :class="TrayData.length > 3 ?'inspiration-gallery-item-container':''" v-if="TrayData">
      <div class="col-sm-4" v-for="(item, index) in selectedOption === 'Brand' ? filteredTrayData : TrayData" :key="index">
        <div
          @click="updateImage(item)"
          class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
          :class="item.id == getselectedTrayId ? 'my-project-feature-image-active' : ''"
        >
          <div class="wf-product-quick-view-swatch-slide">
            <div class="wf-product-quick-view-swatch-slide-image">
              <img class="room-img-thumb" :src="item.coverPhoto" :alt="item.title || ''"
              :style="{ backgroundColor: item.coverPhoto ? '' : '#9f9e9e' }"
              />
            </div>
          </div>
          <div class="medium mb-2 px-2 w-100 text-size-xsmall text-left">
            {{item.title}}</div>
        </div>
      </div>
    <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
    <div v-if="TrayData.length == 0 && !showLoadMore" class="container">
      <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
    </div>
    </div>

  </div>
</template>
<script>
import PcSearch from "../../../../../../src/vue/components/my-trays-page/pc-search.vue";
import { mapActions, mapGetters } from "vuex";
import PcLoadMore from "../../../common/pc-loading-more.vue";


export default {
  data() {
    return {
      virtualTrayTypes: [
      {
          value: "Active",
          label: this.$resourceString['account.Header.Active.Trays']
        },
        {
          value: "Shared",
          label: this.$resourceString['account.Header.SharedTrays.Trays'] //"Shared Trays"
        },
        {
          value: "Brand",
          label: this.$resourceString['account.Header.Premix.Trays']
        }
      ],
      showClearIcon: false,
      selectedOption:"Active",
    };
  },
  components: {
    PcSearch,
    PcLoadMore
  },
  mounted() {
    this.updateTabName(this.selectedOption);
    this.updateSearchInput("");

  },
  computed: {
      ...mapGetters({ TrayData: "myTray/getAllVirtualTrayBoardData" ,
      showLoadMore: "myTray/showLoadMore",
      isFetching: "myTray/getLoader",
      getselectedTrayId:"contentWizard/getselectedTrayId"

    }),
    filteredTrayData() {
      if (this.selectedOption == "Brand") {
        return this.TrayData.filter((card) => card.brandBoardStatus == 2);

    }},
    },
  methods: {
    ...mapActions({
      updateProductSearchTerm: "contentWizard/updateProductSearchTerm",
      updateAllVirtualTray: "myTray/updateAllVirtualTray",
      loadMoreData: "myTray/loadMoreData",
      updateTabName: "myTray/updateTabName",
      updateselectedTrayId:"contentWizard/updateselectedTrayId",
      updateSearchInput: "myTray/updateSearchInput",
      setContentItem:"contentWizard/setContentItem"

    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.loadMoreData();
    },

    async updateSearchQuery(e) {
      await this.updateProductSearchTerm(e.target.value);
    },
    async handleVirtualTraySearch() {
      await this.fetchproductSearch();
    },
    updateImage(item) {
      if (item.id) {
        this.updateselectedTrayId(item.id);
        this.setContentItem({
        title: item.title,
        coverPhoto: item.coverPhoto,
        coverPhotoImageAltText: item.title || '',
        itemBoardId: item.id,
      });
      } else {
        this.updateselectedTrayId("") ;
      }
    },
    handleTrayType(){
      this.updateTabName(this.selectedOption);

    }
  }
};
</script>
